/**
 * @param birthDate A birth date in ISO format (YYYY-MM-DD)
 * @returns Boolean indicating if the string contains a valid birth date
 */
export function validateBirthDate(birthDate: string): boolean {
  if (!birthDate?.trim()) return false
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthDate)) return false

  const [year, month, day] = birthDate.split('-').map(Number)
  const date = new Date(year, month - 1, day)

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return false
  }

  if (year < 1900) return false

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return date <= today
}
